"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var configuration_1 = require("./configuration");

var SurfaceKeys;

(function (SurfaceKeys) {
  SurfaceKeys["Color"] = "color";
  SurfaceKeys["GelCoat"] = "gelCoat";
})(SurfaceKeys = exports.SurfaceKeys || (exports.SurfaceKeys = {}));

var Surface =
/** @class */
function (_super) {
  __extends(Surface, _super);

  function Surface() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Surface.prototype.handle = function () {
    var _this = this;

    if (this.prevKey && this[this.prevKey] === null) {
      return null;
    }

    var data = {};
    Object.keys(SurfaceKeys).forEach(function (key) {
      var _a;

      return lodash_1.assign(data, (_a = {}, _a[SurfaceKeys[key]] = _this[SurfaceKeys[key]], _a));
    });
    return data;
  };

  Surface.prototype.handleDefaults = function () {
    var defaults = this.default; // const data = this.handle() as PlateSurfaceModel;

    return defaults;
  };

  Object.defineProperty(Surface.prototype, "color", {
    get: function get() {
      if (!this.surface) {
        return this.getDefault(configuration_1.ConfigurationKeys.Surface, SurfaceKeys.Color).default;
      }

      return this.surface.color;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Surface.prototype, "gelCoat", {
    get: function get() {
      if (!this.surface || this.isNewTrough) {
        if (this.isNewVariusMedRwt || this.isVariusMedRwt) {
          return true;
        } else {
          return this.getDefault(configuration_1.ConfigurationKeys.Surface, SurfaceKeys.GelCoat).default;
        }
      }

      return this.surface.gelCoat;
    },
    enumerable: true,
    configurable: true
  });
  return Surface;
}(configuration_1.Configuration);

exports.Surface = Surface;